import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DATE_RANGES } from '../../common/constants';
import useLeaderboardStore from './state-hook';
import { MainText, SecondaryText } from './styles';
import Diff from '../../common/diff';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 130px;

  & > .header {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 4px;

    > .main { ${MainText}; }
    > .secondary { ${SecondaryText}; }
  }

  & > .values {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding-right: 4px;

    > .direction {
      flex-grow: 2;
      flex-basis: 50%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      > .row {
        padding-right: 4px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      > .row:not(.dir) {
        color: ${props => props.theme.secondaryColor};
      }

      > .row.dir > span:nth-child(2) {
        display: none;
      }
    }

    > .number {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      /* stylelint-disable no-descending-specificity */
      > .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: -8px;
        padding-right: 4px;
        font-weight: ${props => props.theme.fontWeightHeavy};
      }
      /* stylelint-enable no-descending-specificity */

      > .row.num > span:first-child {
        display: none;
      }
    }
  }
`;

const Dir = ({ n }) => {
  if (!Number.isFinite(n) || !n) {
    return <span className="row" />;
  }

  return (
    <span className="row dir">
      <Diff value={n} />
    </span>
  );
};

Dir.propTypes = { n: PropTypes.number.isRequired };

const Num = ({ n }) => {
  if (!Number.isFinite(n)) {
    return <span className="row grey">-</span>;
  }

  if (!n) {
    return <span className="row" />;
  }

  return (
    <span className="row num">
      <Diff value={n} />
    </span>
  );
};

Num.propTypes = { n: PropTypes.number.isRequired };

export default function Previous() {
  const current = useLeaderboardStore(state => state.current);
  const comparable = useLeaderboardStore(state => state.comparable);
  const daysAgo = useLeaderboardStore(state => state.daysAgo);
  const isAllTime = !Number.isFinite(daysAgo);

  const diffs = current.map(({ id, rank }) => ({ id, diff: comparable[id] - rank }));

  const dateName = React.useCallback(
    () => `${_.find(DATE_RANGES, { value: daysAgo }).label} ago`,
    [daysAgo],
  );

  return (
    <Column>
      <div className="header">
        <span className="main">vs rank</span>
        {!isAllTime && <span className="secondary">{dateName()}</span>}
      </div>
      <div className="values">
        <div className="direction">
          {diffs.map(d => <Dir key={d.id} n={d.diff} />)}
        </div>
        <div className="number">
          {diffs.map(d => <Num key={d.id} n={d.diff} />)}
        </div>
      </div>
    </Column>
  );
}
